import React from 'react';
import PropTypes from 'prop-types';
import { connectToStores } from 'fluxible-addons-react';
import ApplicationStore from '../../../stores/ApplicationStore';
import QuickstartStore from '../../../stores/QuickstartStore';
import UserStore from '../../../stores/UserStore';
import styles from '../styles.module.styl';
import Login from './Login';
import CreateResource from './CreateResource';
import SelectResource from './SelectResource';

const CodeBlockHeader = ({
  isAuthenticated,
  isApiIdInCode,
  isClientIdInCode,
  userClientsByType,
  userClients,
  userApis,
  selectedClientId,
  selectedApiId,
  dashboardClientsUrl,
  dashboardApisUrl,
  children,
  currentQuickstartType
}, context) => {
  const handleUserResourceChange = (action, selectedId) => {
    context.executeAction(action, { selectedId });
  };

  const userHasClient = !!userClients.length;
  const userHasApi = !!userApis.length;
  const showCreateClientMessage = isClientIdInCode && !userHasClient;
  const showCreateApiMessage = isApiIdInCode && !userHasApi;
  const showCreateResourceText = showCreateClientMessage || showCreateApiMessage;

  let state;
  if (!isAuthenticated) {
    state = 'LOGIN';
  } else {
    state = showCreateResourceText ? 'CREATE_RESOURCE' : 'SELECT_RESOURCE';
  }

  return (
    <div className={styles.header}>
      {{
        LOGIN: <Login />,
        CREATE_RESOURCE: <CreateResource
          showCreateClientMessage={showCreateClientMessage}
          dashboardClientsUrl={dashboardClientsUrl}
          dashboardApisUrl={dashboardApisUrl}
          currentQuickstartType={currentQuickstartType}
        />,
        SELECT_RESOURCE: <SelectResource
          selectedClientId={selectedClientId}
          selectedApiId={selectedApiId}
          userApis={userApis}
          isApiIdInCode={isApiIdInCode}
          isClientIdInCode={isClientIdInCode}
          userClients={userClients}
          userClientsByType={userClientsByType}
          handleUserResourceChange={handleUserResourceChange}
        />,
        default: null
      }[state]}
      {children}
    </div>
  );
};

CodeBlockHeader.contextTypes = {
  executeAction: PropTypes.func
};

CodeBlockHeader.propTypes = {
  isAuthenticated: PropTypes.bool.isRequired,
  isApiIdInCode: PropTypes.bool.isRequired,
  isClientIdInCode: PropTypes.bool.isRequired,
  userClients: PropTypes.array.isRequired,
  userClientsByType: PropTypes.object.isRequired,
  userApis: PropTypes.array.isRequired,
  selectedClientId: PropTypes.string.isRequired,
  selectedApiId: PropTypes.string.isRequired,
  dashboardClientsUrl: PropTypes.string.isRequired,
  dashboardApisUrl: PropTypes.string.isRequired,
  children: PropTypes.element.isRequired,
  currentQuickstartType: PropTypes.string
};

export default connectToStores(
  CodeBlockHeader,
  [ApplicationStore, UserStore],
  (context) => {
    const applicationStore = context.getStore(ApplicationStore);
    const userStore = context.getStore(UserStore);
    const currentQuickstartType = context.getStore(QuickstartStore).getQuickstartType();

    return {
      isAuthenticated: userStore.isAuthenticated(),
      userClients: userStore.getQuickstartCompatibleClients(currentQuickstartType),
      userClientsByType: userStore.getQuickstartCompatibleClientsByType(currentQuickstartType),
      userApis: userStore.getApis(),
      selectedClientId: userStore.getSelectedClientId(),
      selectedApiId: userStore.getSelectedApiId(),
      dashboardClientsUrl: applicationStore.getDashboardClientsUrl(),
      dashboardApisUrl: applicationStore.getDashboardApisUrl(),
      currentQuickstartType
    };
  }
);

